<template>
  <GetInTouchFormSection v-if="openGetInTouchForm" @closeForm="openGetInTouchForm = false" />
  <footer class="site-footer">
    <div class="container" style="margin-left: 100px;">
      <!-- <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/index/Square1.svg" style="position: absolute; width: 72px; top: 0; left: 0;"></img>
      <img loading="lazy" src="https://measiteassetpublic.zohostratus.in/img/index/Square2.svg" style="position: absolute; width: 72px; bottom: 20px; right: 300px;"></img> -->
      <!-- height:auto for the same reason as SliderSection: the inline width
           overrides the width attribute while the height attribute stays pinned,
           so these squares rendered 72x155 and 72x106 instead of 72x72. -->
      <img
        v-for="(square, index) in content.decorations"
        :key="index"
        :width="square.width"
        :height="square.height"
        loading="lazy"
        :src="square.src"
        :style="square.style"
        alt=""
      >
      <div class="row justify-content-space-between">
        <div class="col-lg-4">
          <div class="widget">
            <!-- <a href="#" class="footer-logo"><img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/mea.svg'" alt="" /></a> -->
            <!-- <a href="#" class="footer-logo"><img loading="lazy" :src="'https://measiteassetpublic.zohostratus.in/img/footer.svg'" alt="" /></a> -->
            <a href="#" class="footer-logo"><img :width="content.logo.width" :height="content.logo.height" loading="lazy" :src="content.logo.src" :alt="content.logo.alt" /></a>

          </div>
          <div class="widget">
            <ul class="list-unstyled social">
              <li v-for="link in content.social" :key="link.label">
                <a :href="link.href" target="_blank" :aria-label="link.label"><span :class="link.icon"></span></a>
              </li>
              <!-- <li>
                <a href="#" target="_blank"><span class="bx bxl-youtube"></span></a>
              </li> -->
              <!-- <li>
                <a href="#"><span class="twitter"></span></a>
              </li> -->
            </ul>
          </div>
        </div>


        <div class="col-lg-8">
          <div class="widget">
            <h2>{{ content.heading }}<span style="color: #0172F5; font-weight: bold;">{{ content.headingHighlight }}</span></h2>
            <p>{{ content.description }}</p>
          </div>
        </div>
      </div>


    </div>
    <div class="footer-bottom">
          <p>&copy; {{ new Date().getFullYear() }} {{ content.copyright }}</p>
        </div>
    <!-- container -->
  </footer>
  <!-- footer -->
</template>

<script>
import GetInTouchFormSection from './GetInTouchFormSection.vue';
import homeContent from '@/assets/home-content.json';

export default {
  name: "HomeFooterView",
  components: {
    GetInTouchFormSection
  },
  props: {
    // Defaulted: every other view in the app renders this footer without
    // passing anything, and must keep doing so.
    content: {
      type: Object,
      default: () => homeContent.HomeFooterView
    }
  },
  data() {
    return {
      openGetInTouchForm: false
    }
  }
};
</script>

<style>
#site-footer::after, #site-footer::before {
 content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200px;
    height: 200px;
    /* background: url(https://measiteassetpublic.zohostratus.in/img/pattern1.png) no-repeat; */
    background: url("https://measiteassetpublic.zohostratus.in/footer/pattern1.png") no-repeat;
    background-position: center;
    background-size: 100%;
    z-index: 1;
}

</style>